import { PdfInfo } from "PdfInfo";
export class ContractYearList {
    Year: number;
    PdfInfos: PdfInfo[];
    constructor(year: number, pdfInfos: PdfInfo[]) {
        this.Year = year;
        this.PdfInfos = pdfInfos;
    }
}